<div class="logo">
    <img data-auto-id="logo" src="../../../../assets/images/cinch-logo.svg" alt="logo"/>
</div>